import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TableStyleUtility from "./table-style-utility";

function mapStateToProps(state) {
  return {
    transactions: state.transactions,
    texts: state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(mapStateToProps, mapDispatchToProps)(TableStyleUtility);
